import z from "zod";

export const ebookFlowSearchValidator = z.object({
  jobId: z.string().optional(),
  skipToCharacter: z.string().optional(),
});

export type EbookFlowSearchParams = z.infer<typeof ebookFlowSearchValidator>;
